import { type ChartOptions } from "chart.js";

import { type MetricPrecision } from "@north-beam/nb-common/formatting";

export const getDerivedKpiChartOptions = (
  formatter: (value: number, precision?: MetricPrecision) => string,
): ChartOptions<"bar"> => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    title: { display: false },
    tooltip: { enabled: false },
  },
  scales: {
    x: {
      grid: {
        drawOnChartArea: false,
        drawTicks: false,
        drawBorder: false,
      },
      ticks: {
        display: false,
      },
    },
    y: {
      beginAtZero: true,
      grid: {
        drawOnChartArea: true,
        drawTicks: false,
        drawBorder: false,
      },
      ticks: {
        maxTicksLimit: 3,
        count: 3,
        precision: 0,
        callback: (value) => formatter(Number(value)),
        font: {
          family: "Commons Pro Mono",
          size: 13,
        },
      },
    },
  },
});
